module.exports = __webpack_public_path__ + "img/clear.0dd8cf79.png";